const fr = {
  a11yVideoLabelText: "Vidéo montrant la vérification de la vivacité faciale",
  cameraMinSpecificationsHeadingText: "Spécifications minimales de la caméra",
  cameraMinSpecificationsMessageText:
    "Veuillez vous assurer que votre caméra répond aux spécifications minimales requises pour la vérification de la vivacité.",
  cameraNotFoundHeadingText: "Caméra non trouvée",
  cameraNotFoundMessageText:
    "Nous n'avons pas pu détecter de caméra. Veuillez vous assurer que votre caméra est connectée et réessayez.",
  cancelLivenessCheckText: "Annuler la vérification de la vivacité",
  clientHeaderText: "Message du client",
  clientMessageText:
    "Veuillez suivre les instructions à l'écran pour compléter la vérification de la vivacité faciale.",
  connectionTimeoutHeaderText: "Temps de connexion écoulé",
  connectionTimeoutMessageText:
    "La connexion a expiré. Veuillez vérifier votre connexion Internet et réessayer.",
  errorLabelText: "Erreur",
  faceDistanceHeaderText: "Distance faciale",
  faceDistanceMessageText:
    "Veuillez vous assurer que votre visage est à la bonne distance de la caméra.",
  goodFitAltText: "Le visage est bien aligné",
  goodFitCaptionText: "Votre visage est bien aligné. Veuillez rester immobile.",
  hintCanNotIdentifyText:
    "Impossible d'identifier le visage. Veuillez réessayer.",
  hintCenterFaceInstructionText: "Centre votre visage dans le cadre.",
  hintCenterFaceText: "Centre votre visage",
  hintCheckCompleteText: "Vérification complète",
  hintConnectingText: "Connexion...",
  hintFaceDetectedText: "Visage détecté",
  hintFaceOffCenterText: "Votre visage est décentré. Veuillez ajuster.",
  hintHoldFaceForFreshnessText:
    "Gardez votre visage immobile pour la vérification.",
  hintIlluminationNormalText: "L'éclairage est bon",
  hintIlluminationTooBrightText: "L'éclairage est trop lumineux",
  hintIlluminationTooDarkText: "L'éclairage est trop sombre",
  hintMatchIndicatorText: "Comparaison des indicateurs faciaux...",
  hintMoveFaceFrontOfCameraText: "Déplacez votre visage devant la caméra",
  hintTooCloseText: "Vous êtes trop près de la caméra",
  hintTooFarText: "Vous êtes trop loin de la caméra",
  hintTooManyFacesText:
    "Trop de visages détectés. Un seul visage doit être dans le cadre.",
  hintVerifyingText: "Vérification...",
  landscapeHeaderText: "Mode paysage détecté",
  landscapeMessageText:
    "Veuillez passer en mode portrait pour la vérification de la vivacité.",
  multipleFacesHeaderText: "Plusieurs visages détectés",
  multipleFacesMessageText:
    "Un seul visage doit être dans le cadre. Veuillez ajuster et réessayer.",
  photosensitivityWarningBodyText:
    "Cette vérification implique une série de stimuli visuels. Si vous avez des problèmes de photosensibilité, procédez avec prudence.",
  photosensitivityWarningHeadingText: "Avertissement de photosensibilité",
  photosensitivityWarningInfoText:
    "Vous pouvez arrêter la vérification à tout moment si vous ressentez une gêne.",
  photosensitivityWarningLabelText: "Je comprends les risques",
  portraitMessageText: "Veuillez tenir votre appareil en mode portrait.",
  recordingIndicatorText: "Enregistrement en cours",
  retryCameraPermissionsText: "Réessayer les autorisations de la caméra",
  serverHeaderText: "Problème de serveur",
  serverMessageText:
    "Il y a eu un problème de connexion au serveur. Veuillez réessayer plus tard.",
  startScreenBeginCheckText: "Commencer la vérification de la vivacité",
  timeoutHeaderText: "Délai d'attente écoulé",
  timeoutMessageText: "Le processus a expiré. Veuillez réessayer.",
  tooFarAltText: "Le visage est trop loin de la caméra",
  tooFarCaptionText: "Veuillez vous rapprocher de la caméra.",
  tryAgainText: "Réessayer",
  waitingCameraPermissionText: "En attente de l'autorisation de la caméra...",
};

export default fr;
